// Shared name-handling utilities so glow lookup and selection compare identically.

export function normalizeStateName(name: string | null): string | null {
  const mapping: Record<string, string> = {
    "New York State": "New York",
    "District of Columbia": "Washington DC",
  };
  return mapping[name ?? ""] ?? name?.trim() ?? null;
}

export const glowId = (name: string | null | undefined): string =>
  (name || "").toLowerCase().trim();

export const glassStyle: React.CSSProperties = {
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  background: "rgba(8,10,18,0.72)",
  border: "1px solid rgba(255,255,255,0.10)",
  boxShadow: "0 12px 40px rgba(0,0,0,0.55)",
  color: "#fff",
  fontFamily: "sans-serif",
};
